import { State } from "./state";
import { storeInit } from "../../../Store";

const initialData: State.Data = {
  mask: "",
  facpTamper: false,
  acCommTrbl: false,
  battTamper: false,
  calib: false,
  calZeros: 0,
  port_calib: false,
  acFail: false,
  battFail: false,
  inpStatus: false,
  tamper: false,
  facp: false,
  wetEol: false,
  relayTgl: false,
  inputTrigger: false,
  resetTamper: false,
  temp: 0,
  thigh: 0
};

export const initial: State.Props = storeInit(initialData);
export default initial;
